import React from 'react';
import { ProjectMaterialsKpiRow } from './ProjectMaterialsKpiRow';
import { ProjectMaterialsHeader } from './ProjectMaterialsHeader';
import { ProjectMaterialsList } from './ProjectMaterialsList';
import { ProjectMaterialsSidebar } from './ProjectMaterialsSidebar';
import { useProjectMaterials } from '../hooks/useProjectMaterials';

export function ProjectMaterialsMain() {
  const { data, isLoading } = useProjectMaterials();

  if (isLoading) {
    return <div className="p-10 text-center text-slate-400">Đang tải dữ liệu vật tư...</div>;
  }

  return (
    <div className="space-y-6">
      {/* KPI Row */}
      <ProjectMaterialsKpiRow kpis={data.kpis} />

      <div className="grid grid-cols-1 xl:grid-cols-12 gap-6 items-start">
        {/* Main Content */}
        <div className="xl:col-span-9 space-y-6">
          <ProjectMaterialsHeader />
          <ProjectMaterialsList materials={data.materials} />
        </div>

        {/* Sidebar */}
        <div className="xl:col-span-3">
          <ProjectMaterialsSidebar data={data} />
        </div>
      </div>
    </div>
  );
}
